// Per-order state inside a bulk-assign run.
export const BULK_STATUS = {
  waiting: "waiting",
  checking: "checking",
  eligible: "eligible",
  unsupported: "unsupported",
  assigning: "assigning",
  assigned: "assigned",
  failed: "failed",
  stopped: "stopped",
  // The server says this order no longer needs a carrier (it already has one,
  // or it was cancelled/completed). Never touched by the run.
  alreadyAssigned: "alreadyAssigned",
};

// Statuses that will never be assigned by this run.
export const BULK_SETTLED_STATUSES = [
  BULK_STATUS.assigned,
  BULK_STATUS.alreadyAssigned,
];

const ORDER_PENDING = "ORDER_PENDING";

/**
 * Only a pending order can be given a shipping company. A missing
 * `currentStatus` is treated as pending so a partial payload never hides an
 * order from the run.
 */
export const needsCarrier = (order) =>
  !order?.currentStatus || order.currentStatus === ORDER_PENDING;

// Run-level phase, drives the stepper and the footer buttons.
export const BULK_PHASE = {
  carrier: "carrier",
  checking: "checking",
  assigning: "assigning",
  done: "done",
};

// User control over a live run.
export const BULK_CONTROL = {
  running: "running",
  paused: "paused",
  stopped: "stopped",
};

// How many orders are in flight at once, for both the availability scan and the
// assignment pass. Deliberately small: every order is a separate request to the
// shipping-company integration.
export const BULK_CONCURRENCY = 3;

// Buckets the run table and the results screen group rows by.
export const BULK_BUCKETS = {
  all: "all",
  assigned: "assigned",
  failed: "failed",
  unsupported: "unsupported",
  waiting: "waiting",
};

export const BULK_STATUS_COLOR = {
  [BULK_STATUS.waiting]: "text.lighter",
  [BULK_STATUS.checking]: "info.main",
  [BULK_STATUS.eligible]: "info.main",
  [BULK_STATUS.unsupported]: "warning.main",
  [BULK_STATUS.assigning]: "info.main",
  [BULK_STATUS.assigned]: "success.main",
  [BULK_STATUS.failed]: "error.main",
  [BULK_STATUS.stopped]: "text.lighter",
  [BULK_STATUS.alreadyAssigned]: "text.lighter",
};
